import React from 'react';
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import image from "../../assets/m2c.png";
import "./NavBar.css";

const NavBar = () => {
  return (
    <div className='NavBars'>
      <nav className='my-nav'>
        <a href='/'><img src={image} alt='logo' className='m2clogo' /></a>

        <div className='elements'>
          {/* Email link */}
          <a 
            href="mailto:info@m2c.international" 
            className="contact-button email-btn"
          >
            <FaEnvelope className="icon" />
            <span>info@m2c.international</span>
          </a>

          {/* WhatsApp link */}
          <a 
            href="https://wa.me/17477772758"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button whatsapp-btn"
          >
            <FaWhatsapp className="icon" />
            <span>+1 (747) 777-2758</span>
          </a>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
